import React, { Component } from 'react';

const sections = [
  {
    title: '1. บัญชีผู้ใช้',
    content: [
      'สมาชิกต้องมีอายุ 18 ปีบริบูรณ์ขึ้นไปจึงจะมีสิทธิ์สมัครใช้งาน',
      'สมาชิกสามารถมีได้เพียง 1 บัญชีเท่านั้น การสมัครหลายบัญชีอาจส่งผลให้บัญชีถูกระงับ',
      'ข้อมูลที่ให้ไว้ต้องถูกต้องและเป็นปัจจุบัน PK8ขอสงวนสิทธิ์ในการร้องขอเอกสารยืนยันตัวตน',
      'สมาชิกต้องรับผิดชอบในการรักษาความลับของรหัสผ่านและบัญชีตนเอง',
    ],
  },
  {
    title: '2. การฝากและถอนเงิน',
    content: [
      'การฝากเงินจะถูกประมวลผลทันทีหลังจากได้รับการยืนยัน',
      'ยอดถอนสูงสุดต่อครั้งและต่อวันเป็นไปตามระดับ VIP ของสมาชิก',
      'PK8ขอสงวนสิทธิ์ในการตรวจสอบและขอเอกสารก่อนอนุมัติการถอนเงิน',
      'สมาชิกต้องใช้บัญชีธนาคารในชื่อตนเองเท่านั้นสำหรับการทำธุรกรรม',
      'การถอนเงินอาจใช้เวลา 3–5 วันทำการขึ้นอยู่กับธนาคาร',
    ],
  },
  {
    title: '3. โบนัสและโปรโมชั่น',
    content: [
      'โบนัสทุกประเภทต้องปฏิบัติตามเงื่อนไขการวางเดิมพันที่กำหนด',
      'PK8ขอสงวนสิทธิ์ในการยกเลิกโบนัสหากตรวจพบการใช้งานที่ผิดเงื่อนไข',
      'โปรโมชั่นไม่สามารถใช้ร่วมกันได้ เว้นแต่จะระบุไว้เป็นอย่างอื่น',
      'PK8ขอสงวนสิทธิ์ในการเปลี่ยนแปลงหรือยกเลิกโปรโมชั่นโดยไม่ต้องแจ้งล่วงหน้า',
    ],
  },
  {
    title: '4. กฎการเดิมพัน',
    content: [
      'สมาชิกต้องรับผิดชอบต่อการเดิมพันที่วางไว้ทั้งหมด',
      'PK8ขอสงวนสิทธิ์ในการยกเลิกการเดิมพันที่เกิดจากข้อผิดพลาดทางเทคนิค',
      'ผลการตัดสินของระบบถือเป็นที่สิ้นสุด',
      'การเดิมพันในขณะที่มีข้อพิพาทหรือข้อผิดพลาดที่ทราบอยู่แล้วจะเป็นโมฆะ',
    ],
  },
  {
    title: '5. ข้อห้ามและการระงับบัญชี',
    content: [
      'ห้ามใช้ซอฟต์แวร์อัตโนมัติ บอท หรือระบบใด ๆ เพื่อเดิมพัน',
      'ห้ามสมคบกันเพื่อหลอกลวงหรือทุจริตในระบบ',
      'ห้ามใช้บัญชีของผู้อื่นหรืออนุญาตให้ผู้อื่นใช้บัญชีของตน',
      'การฝ่าฝืนข้อห้ามดังกล่าวอาจนำไปสู่การระงับบัญชีและการยึดยอดเงิน',
    ],
  },
  {
    title: '6. ความเป็นส่วนตัวและข้อมูลส่วนบุคคล',
    content: [
      'PK8จะเก็บรวบรวมและใช้ข้อมูลส่วนบุคคลตามนโยบายความเป็นส่วนตัว',
      'ข้อมูลของสมาชิกจะไม่ถูกเปิดเผยต่อบุคคลที่สามโดยไม่ได้รับความยินยอม เว้นแต่กฎหมายกำหนด',
      'สมาชิกยินยอมให้ PK8ส่งข้อมูลโปรโมชั่นผ่านช่องทางที่ลงทะเบียนไว้',
    ],
  },
  {
    title: '7. ข้อจำกัดความรับผิดชอบ',
    content: [
      'PK8จะไม่รับผิดชอบต่อความเสียหายที่เกิดจากการหยุดชะงักของระบบ',
      'PK8ไม่รับผิดชอบต่อการสูญเสียที่เกิดจากการตัดสินใจเดิมพันของสมาชิก',
      'PK8ขอสงวนสิทธิ์ในการระงับบริการชั่วคราวเพื่อการบำรุงรักษา',
    ],
  },
  {
    title: '8. การเปลี่ยนแปลงข้อกำหนด',
    content: [
      'PK8ขอสงวนสิทธิ์ในการแก้ไขข้อกำหนดและเงื่อนไขได้ทุกเมื่อ',
      'การเปลี่ยนแปลงสำคัญจะแจ้งให้สมาชิกทราบผ่านอีเมลหรือกล่องข้อความในระบบ',
      'การใช้งานต่อเนื่องหลังการแจ้งเปลี่ยนแปลงถือว่าสมาชิกยอมรับข้อกำหนดใหม่',
    ],
  },
];

class TncPage extends Component {
  constructor(props) {
    super(props);
    this.state = { openSection: null };
  }

  toggle(idx) {
    this.setState(prev => ({ openSection: prev.openSection === idx ? null : idx }));
  }

  render() {
    const { openSection } = this.state;

    return (
      <div style={{ background: '#0a1628', minHeight: '100vh', fontFamily: 'Noto Sans Thai, sans-serif', color: '#fff' }}>

        {/* ── Hero ── */}
        <div style={{
          background: 'linear-gradient(135deg, #051030 0%, #0d2348 60%, #1a3a6e 100%)',
          padding: '56px 24px 40px',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: 12, color: '#f5a623', letterSpacing: 3, marginBottom: 8, textTransform: 'uppercase' }}>Legal</div>
          <h1 style={{ fontSize: 26, fontWeight: 800, margin: '0 0 12px' }}>ข้อกำหนดและเงื่อนไข</h1>
          <p style={{ fontSize: 13, color: '#8aaccc', maxWidth: 500, margin: '0 auto' }}>
            กรุณาอ่านข้อกำหนดและเงื่อนไขเหล่านี้อย่างละเอียดก่อนใช้งานบริการของ PK8
          </p>
          <div style={{ marginTop: 16, fontSize: 12, color: '#4a6a8a' }}>
            อัปเดตล่าสุด: 1 มกราคม 2026
          </div>
        </div>

        {/* ── Intro ── */}
        <div style={{ maxWidth: 760, margin: '32px auto 0', padding: '0 20px' }}>
          <div style={{ background: '#0d2040', borderRadius: 10, padding: '20px 24px', border: '1px solid #1e3560', fontSize: 13, color: '#c8d6e5', lineHeight: 1.9 }}>
            ข้อกำหนดและเงื่อนไขฉบับนี้เป็นสัญญาผูกพันระหว่างสมาชิก ("ท่าน") กับ Mettlemind Tech Ltd. ซึ่งดำเนินการเว็บไซต์ PK8("PK8", "เรา") การสมัครสมาชิกหรือใช้งานบริการของ PK8ถือว่าท่านยอมรับข้อกำหนดและเงื่อนไขเหล่านี้ทั้งหมด
          </div>
        </div>

        {/* ── Accordion Sections ── */}
        <div style={{ maxWidth: 760, margin: '24px auto 48px', padding: '0 20px' }}>
          {sections.map((sec, idx) => {
            const isOpen = openSection === idx;
            return (
              <div key={idx} style={{ marginBottom: 8, borderRadius: 10, overflow: 'hidden', border: '1px solid #1e3560' }}>
                <button
                  onClick={() => this.toggle(idx)}
                  style={{
                    width: '100%', textAlign: 'left', background: isOpen ? '#0e2a50' : '#0d1f3c',
                    border: 'none', cursor: 'pointer', padding: '16px 20px',
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    color: isOpen ? '#f5a623' : '#c8d6e5', fontFamily: 'inherit',
                    fontWeight: isOpen ? 700 : 500, fontSize: 14,
                    transition: 'background .2s',
                  }}
                >
                  <span>{sec.title}</span>
                  <span style={{ fontSize: 18, lineHeight: 1, color: '#f5a623' }}>{isOpen ? '−' : '+'}</span>
                </button>
                {isOpen && (
                  <div style={{ background: '#081524', padding: '16px 20px 20px' }}>
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                      {sec.content.map((item, i) => (
                        <li key={i} style={{ color: '#8aaccc', fontSize: 13, lineHeight: 1.9, marginBottom: 4 }}>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* ── Footer note ── */}
        <div style={{ maxWidth: 760, margin: '0 auto 40px', padding: '0 20px' }}>
          <div style={{ background: '#0d1f3c', borderRadius: 10, padding: '20px 24px', border: '1px solid #1e3560', fontSize: 12, color: '#4a6a8a', lineHeight: 1.8, textAlign: 'center' }}>
            PK8ดำเนินการโดยบริษัท Mettlemind Tech Ltd. ได้รับใบอนุญาตจาก Anjouan Gaming Board<br />
            หากมีข้อสงสัยโปรดติดต่อทีมสนับสนุนของเราตลอด 24 ชั่วโมง
          </div>
        </div>

      </div>
    );
  }
}

export default TncPage;
